module.exports = __webpack_public_path__ + "img/pic2.d56abac6.png";